<template>
  <v-chip :color="color">{{ label }}</v-chip>
</template>

<script setup lang="ts">
// import {
//   TASK_ACTIVE,
//   TASK_CANCELLED,
//   TASK_COMPLETED,
//   TASK_NOT_STARTED,
//   TASK_PAUSED,
// } from '@/models/unit_number'
import { getTaskStatusColor, getTaskStatusText } from '@/utils/status-formatting'
import { formatDurationAsHours } from '@/utils/date-formatting'
import { computed } from 'vue'
import type { Duration } from 'moment'

const props = defineProps<{
  // props.status should be of type:
  // | TASK_ACTIVE
  // | TASK_CANCELLED
  // | TASK_COMPLETED
  // | TASK_NOT_STARTED
  // | TASK_PAUSED

  // The reason we can't declare this type here is because of Vue <= 3.2 limitation:
  // "In Vue 3.2 and below, the generic type parameter for defineProps() were limited to a type literal or a reference to a local interface."
  // https://vuejs.org/guide/typescript/composition-api#syntax-limitations
  // Once we upgrade to Vue 3.3, we can properly declare the type of props.status
  status: string
  activeDuration?: Duration | null
}>()

const color = computed(() => getTaskStatusColor(props.status))
const label = computed(() =>
  props.activeDuration
    ? formatDurationAsHours(props.activeDuration, true)
    : getTaskStatusText(props.status),
)
</script>
